<template lang="pug">
  .edit-profile
    .container-fluid.edit-profile-page-title
      .container
        .row.py-3
          .col-5
            h3.title-path
              router-link(:to="{ name: 'ProfilePage' }") {{ $t('profile.profile') }}
              span#arrow-delimiter >
              span {{ $t('profile.edit_profile') }}
            h1 {{ $t('profile.edit_profile') }}
          .col.text-right.pt-2
            router-link#cancel-link(
              :to="{ name: 'ProfilePage' }"
              class="btn btn-outline-primary mr-3 px-4 py-0"
            )
              | {{ $t('profile.cancel') }}
            input.btn.btn-primary.px-4.py-0#edit-profile-button(
              :value="$t('profile.save')"
              type='button'
              :disabled="disabledSave"
              @click="saveChanges"
            )
    .container-fluid.edit-profile-inputs
      .container
        .inputs-selects
          .first-name
            p {{ $t('edit_profile.first_name') }} ({{ $t('edit_profile.full') }}) *
            input(
              :class="{ 'red-bordered': v_errors.first('first_name') }"
              v-model="profile.first_name"
              v-validate="'required'"
              name="first_name"
              type="text"
            )
            .error
              | {{ v_errors.first('first_name') }}
          .last-name
            p {{ $t('edit_profile.last_name') }} ({{ $t('edit_profile.full') }}) *
            input(
              :class="{ 'red-bordered': v_errors.first('last_name') }"
              v-model="profile.last_name"
              v-validate="'required'"
              name="last_name"
              type="text"
            )
            .error
              | {{ v_errors.first('last_name') }}
          .department
            p {{ $t('edit_profile.department') }} ({{ $t('edit_profile.full') }}) *
            input(
              :class="{ 'red-bordered': v_errors.first('department') }"
              v-model="profile.department"
              v-validate="'required'"
              name="department"
              type="text"
            )
            .error
              | {{ v_errors.first('department') }}
        .phones-password
          p {{ $t('edit_profile.phones') }}
          ul.phones-list
            li(
              v-for="phone in phones"
              v-if="phone._destroy == 0 || !phone._destroy"
              :key="phone.number"
            )
              span {{ phone.number }} ({{ phone.extension }})
          button(v-b-modal.edit-phones @click="openModalEditPhones") {{ $t('edit_profile.edit_phones') }}
          phones(
            v-if="modals.editPhones"
            :phones="phones"
            @savePhones="savePhones"
            @cancelSavePhones="cancelSavePhones"
          )

</template>

<script>
  import { api } from '@/api'
  import { filter, reject } from 'lodash'
  import toastMixin from '@/mixins/toasts'
  import Phones from '@/pages/Profile/Edit/phones'

  export default {
    components: {
      Phones
    },

    mixins: [toastMixin],

    data() {
      return {
        profile: {},
        organizations: [],
        phones: [],
        modals: {
          editPhones: false
        }
      }
    },

    computed: {
      profileUrl() {
        return '/profiles'
      },

      disabledSave() {
        return this.v_errors.any() || this.phonesCount == 0
      },

      full_name() {
        return `${this.profile.first_name} ${this.profile.last_name}`
      },

      existsPhones() {
        return filter(this.phones, 'id')
      },

      newPhones() {
        return reject(this.phones, 'id')
      },

      phonesCount() {
        const existLength = reject(this.existsPhones, '_destroy').length
        return this.newPhones.length + existLength
      }
    },

    created() {
      api.get(this.profileUrl).then(({ data: { data: profile, data: { phones } } }) => {
        this.profile = profile
        this.phones = phones
        this.fetchOrganizations()
      }).catch(this.errorLoading)
    },

     methods: {
      fetchOrganizations() {
        api.get('/organizations').then(({ data: { data } }) => {
          this.organizations = data
        }).catch(this.errorLoading)
      },

      saveChanges() {
        if (!this.v_errors.any()) {
          const phones_attributes = this.phones
          const params = { ...this.profile, phones_attributes }
          api.put(this.profileUrl, params).then(({ data: { success } }) => {
            if (success) {
              this.$router.push({ name: 'ProfilePage' })
            }
          }).catch(({ response: { data: { errors } } }) => {
            const { first_name, last_name, department } = errors

            first_name && this.showToast(this.$t('edit_profile.first_name_must_be_filled'))
            last_name && this.showToast(this.$t('edit_profile.last_name_must_be_filled'))
            department && this.showToast(this.$t('edit_profile.department_must_be_filled'))
          })
        }
      },

      errorLoading() {
        this.$router.push({ name: 'ProfilePage' })
        this.$bvToast.show('error-loading')
      },

      openModalEditPhones() {
        this.modals.editPhones = true
      },

      savePhones(phones) {
        this.modals.editPhones = false
        this.phones = phones
      },

      cancelSavePhones() {
        this.modals.editPhones = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .edit-profile-page-title {
    background-color: #fff;
    box-shadow: 0 2px 16px 0 rgba(176, 186, 197, 0.2);
    margin-bottom: 10px;

    h3 {
      color: #7c91a7;
      font-size: 11px;
      font-weight: 700;

      a {
        color: #7c91a7;
        text-decoration: none;
      }
    }

    #arrow-delimiter {
      margin: 0 5px;
    }

    h1 {
      color: #3d4a57;
      font-size: 30px;
      font-weight: 700;
    }

    #cancel-link,
    #edit-profile-button {
      background: transparent;
      border: 1px solid rgba(0, 156, 234, 0.3);
      border-radius: 4px;
      color: #009cea;
      font-size: 14px;
      height: 40px;
      line-height: 38px;
    }

    #edit-profile-button {
      background-image: linear-gradient(90deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);
      border-radius: 4px;
      color: #fff;
      font-size: 14px;
      height: 40px;
      line-height: 38px;
    }
  }

  .edit-profile-inputs {
    p {
      color: #7c91a7;
      font-size: 13px;
      font-weight: 700;
      margin: 10px 0;
    }

    input,
    select {
      border: 1px solid #dfe6ee;
      border-radius: 4px;
      color: #313541;
      font-size: 14px;
      font-weight: 500;
      height: 40px;
      padding: 10px 12px;
      width: 280px;
    }

    .error {
      color: red;
      font-size: 13px;
      margin-top: 5px;
    }

    button {
      background-color: transparent;
      border: 0;
      color: #008bd0;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
    }

    .container {
      display: flex;

      .inputs-selects {
        width: 30%;
      }

      .first-name,
      .last-name,
      .organization,
      .department {
        margin-bottom: 20px;
      }
    }
  }

  @media (max-width: 1000px) {
    .edit-profile-inputs {
      .container {
        flex-direction: column;
      }
    }
  }
</style>
